import { Alert, Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ReactJson from "react-json-view";
import { ILegisWebSimples } from "../../model";
import { LegisWebStore } from "../../stores/admin/LegisWebStore";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import { Pager } from "../utils/Pager";

const InputMask = require("react-input-mask");

interface LegisWebSimplesPageProps {
}

interface LegisWebSimplesPageState {
}

@observer
export class LegisWebSimplesPage
  extends React.Component<LegisWebSimplesPageProps, LegisWebSimplesPageState> {
  obs = observable({
    ncm: "" as string,
    page: 1 as number,
    viewing: {} as ILegisWebSimples,
    duplicate: {} as ILegisWebSimples,
    viewDuplicate: false,
    cest: "",
    varejista: "",
    fabricante: "",
    distribuidor: "",
    atacadista: "",
  })

  constructor(props) {
    super(props);
    this.state = { handlePageChange: props.handlePageChange };
  }

  async componentDidMount() {
    AppStore.setTitle("Legis Web - Simples Nacional");
    LegisWebStore.legisWebSimplesLoad(1);
  }

  handlePageChange = async (page: number) => {
    LegisWebStore.legisWebSimplesLoad(page);
    this.obs.page = page;
  };

  handleBuscaNcm = async () => {
    if (this.obs.ncm != "") {
      await LegisWebStore.buscaNcmSimples(this.obs.ncm);
    } else {
      toast.warning('Digite um NCM.', {});
    }
  };

  async handleDuplicar() {

    let data = {
      to_duplicated: this.obs.duplicate,
      cest: this.obs.cest,
      atacadista: this.obs.atacadista ? this.obs.atacadista : null,
      distribuidor: this.obs.distribuidor ? this.obs.distribuidor : null,
      varejista: this.obs.varejista ? this.obs.varejista : null,
      fabricante: this.obs.fabricante ? this.obs.fabricante : null,
    }

    this.onClose()

    let res = await LegisWebStore.handleDuplicar(data)

    if (res) {

      this.obs.page = 1;

      if (this.obs.ncm != "") {

        await LegisWebStore.buscaNcmSimples(this.obs.ncm);

      } else {

        await LegisWebStore.legisWebSimplesLoad(1);

      }

    }

  }

  async handleDelete(id) {

    let res = await LegisWebStore.handleDelete(id)

    if (res) {

      this.obs.page = 1;

      if (this.obs.ncm != "") {

        await LegisWebStore.buscaNcmSimples(this.obs.ncm);

      } else {

        await LegisWebStore.legisWebSimplesLoad(1);

      }

    }

  }

  onClose() {

    this.obs.viewDuplicate = false
    this.obs.cest = ""
    this.obs.varejista = ""
    this.obs.fabricante = ""
    this.obs.distribuidor = ""
    this.obs.atacadista = ""
    this.obs.duplicate = null

  }

  render() {

    const handleViewResposta = (resp: ILegisWebSimples) => {

      this.obs.viewing = resp;

      LegisWebStore.obs.viewSimplesDetalhes = true;

    };

    const handleDuplicate = (resp: ILegisWebSimples) => {

      this.obs.duplicate = resp;

      this.obs.viewDuplicate = true;

    };

    const btnDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewResposta(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>

          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleDuplicate(row)}
          >
            <img src="/images/duplicate.svg" width="18px" />
          </MDBBtn>

          {row.duplicate &&
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleDelete(row.id)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          }
        </>
      );
    }

    return (
      <>
        <MDBRow xl="12" lg="12" md="12" sm="12">
          <MDBCol xl="2" lg="2" md="2" sm="2">
            <FormGroup label="NCM">
              <InputMask
                mask="9999.99.99"
                className="form-control"
                value={this.obs.ncm}
                onChange={(e) => this.obs.ncm = e.target.value}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleBuscaNcm}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={LegisWebStore.obs.legisweb_simples}
          >
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="ncm" width="10%">NCM</TableHeaderColumn>
            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
            <TableHeaderColumn dataFormat={btnDetalhes} width="15%">Detalhes</TableHeaderColumn>

          </BootstrapTable>
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={LegisWebStore.obs.viewSimplesDetalhes}
          onClose={() => LegisWebStore.obs.viewSimplesDetalhes = false}
          canOutsideClickCancel={true}
          className="AlertResposta"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson
              collapsed={true}
              displayDataTypes={false}
              src={this.obs.viewing}
            />
          </div>
        </Alert>

        <Dialog
          isOpen={this.obs.viewDuplicate}
          onClose={() => this.onClose()}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_BODY}>

            <h2 className="title-no-bottom">Duplicar</h2>

            <FormGroup label="CEST">
              <InputGroup
                value={this.obs.cest}
                onChange={(e) => this.obs.cest = e.target.value}
              />
            </FormGroup>

            <FormGroup label="Varejista">
              <InputGroup
                value={this.obs.varejista}
                onChange={(e) => this.obs.varejista = e.target.value}
              />
            </FormGroup>

            <FormGroup label="Fabricante">
              <InputGroup
                value={this.obs.fabricante}
                onChange={(e) => this.obs.fabricante = e.target.value}
              />
            </FormGroup>

            <FormGroup label="Distribuidor">
              <InputGroup
                value={this.obs.distribuidor}
                onChange={(e) => this.obs.distribuidor = e.target.value}
              />
            </FormGroup>

            <FormGroup label="Atacadista">
              <InputGroup
                value={this.obs.atacadista}
                onChange={(e) => this.obs.atacadista = e.target.value}
              />
            </FormGroup>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onClose()} />
              <Button text="Duplicar" intent="primary" onClick={() => this.handleDuplicar()} />
            </div>
          </div>
        </Dialog>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.page}
            totalCount={LegisWebStore.obs.lengthProduto}
            pageSize={15}
            onPageChange={this.handlePageChange}
          />
        </div>
      </>
    );
  }
}
